export const loadGTM = (id: string, srcOverride?: string) => {
  const scriptId = 'gtm-script'

  const existingScript = document.getElementById(scriptId)
  if (existingScript) {
    existingScript.remove()
  }

  const script = document.createElement('script')
  script.async = true
  script.id = scriptId
  script.src = srcOverride || `https://www.googletagmanager.com/gtm.js?id=${id}`
  document.head.appendChild(script)
}
